var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 73,
    viewBox: "0 0 71 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1410_10297)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.765,
    cy: 34.8431,
    rx: 34.8431,
    ry: 34.8431,
    fill: "#B31616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1082 34.8431C69.1082 53.258 54.1799 68.1863 35.765 68.1863C17.3501 68.1863 2.42188 53.258 2.42188 34.8431C2.42188 16.4282 17.3501 1.5 35.765 1.5C54.1799 1.5 69.1082 16.4282 69.1082 34.8431Z",
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5241 19.0815C36.2731 19.071 36.0231 19.0659 35.774 19.0659C25.8917 19.0659 17.8516 27.1037 17.8516 36.9845C17.8516 46.8661 25.8917 54.9036 35.774 54.9036C45.6563 54.9031 53.6947 46.8657 53.6947 36.9841V36.3871V36.0438L53.6663 36.0329C53.48 33.891 51.68 32.2094 49.4893 32.2094C47.1721 32.2094 45.2923 34.0857 45.2923 36.4035C45.2923 36.5491 45.3011 36.6949 45.3166 36.8358V36.9841C45.3166 42.2453 41.036 46.5263 35.7748 46.5263C30.514 46.5263 26.2326 42.2453 26.2326 36.9841C26.2326 31.7258 30.514 27.4427 35.7748 27.4427C36.0248 27.4427 36.2749 27.4526 36.5249 27.4724V28.5349V28.5592V29.0349H36.5601C36.79 30.5756 38.1196 31.7585 39.7255 31.7585C40.7415 31.7585 41.6349 31.2794 42.2172 30.5503L46.8791 25.8759C47.5218 25.2928 47.9377 24.456 47.9377 23.5115C47.9377 22.4394 47.4094 21.497 46.6062 20.9186L42.0979 16.4041C42.0231 16.3173 41.9456 16.2405 41.8677 16.1709L41.7989 16.1025L41.6526 15.957H41.6007C41.0773 15.5728 40.4334 15.3378 39.725 15.3378C38.1159 15.3378 36.8026 16.5256 36.5734 18.0637L36.5241 18.1013V18.3489V19.0815Z",
    fill: "white",
    stroke: "#600606"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1410_10297",
    x: 0.921875,
    y: 0,
    width: 69.6875,
    height: 72.6863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.701961 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1410_10297"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1410_10297",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/Retry.e92eb2e1e5609be7a8405f01d91d4775.svg";
export { ForwardRef as ReactComponent };